<template>
  <div>
    <v-data-table :headers="headers" :items="templates" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Letter Templates</v-toolbar-title>
          <div class="flex-grow-1">
            <v-btn class="secondary float-right ml-2" @click="mergeFields()"
              ><v-icon left dark>mdi-help-circle</v-icon>Fields</v-btn
            >
            <v-btn class="primary float-right" @click="addTemplate()"
              >Add Template</v-btn
            >
          </div>
        </v-toolbar>
      </template>

      <template v-slot:item.action="{ item }">
        <v-btn color="primary" small class="text-uppercase" @click="edit(item)"
          >Update</v-btn
        >
        &nbsp;
        <v-btn
          small
          color="primary"
          class="text-uppercase"
          @click="preview(item)"
          >Preview</v-btn
        >
        &nbsp;
        <v-btn
          small
          color="primary"
          class="text-uppercase"
          @click="download(item)"
          >Download</v-btn
        >
        &nbsp;
        <v-btn
          small
          color="primary"
          class="text-uppercase"
          @click="deleteTemplate(item)"
          >Delete</v-btn
        >
      </template>
    </v-data-table>

    <letter-dialog
      :dialog="dialog"
      :add="add"
      @done="loadTemplates"
      @cancel="closeDialog"
      :template="template"
    ></letter-dialog>

    <v-dialog
      content-class="previewDialog"
      v-model="previewDialog"
      width="1020"
      height="600"
      persistent
      :scrollable="false"
    >
      <letter-preview
        ref="preview"
        :initialDocFile="initialDocFile"
        :title="template.title"
        @close="previewDialog = false"
      ></letter-preview
    ></v-dialog>

    <v-dialog v-model="mergeFieldsDialog" width="1000" persistent>
      <letter-merge-fields @cancel="closeFieldDialog"></letter-merge-fields>
    </v-dialog>

    <v-dialog v-model="loaderDialog" persistent width="400">
      <v-card color="primary" dark>
        <v-card-text class="pt-3 white--text">
          {{ message }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-2 mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LetterDialog from "@/components/dialogs/LetterDialog";
import LetterPreview from "@/components/dialogs/LetterPreview";
import LetterMergeFields from "@/components/dialogs/LetterMergeFields";
import { LetterTemplate } from "../models/LetterTemplate";
import { HTTP } from "@/http-common";

import { mapActions } from "vuex";
export default {
  name: "Templates",
  components: {
    LetterDialog,
    LetterPreview,
    LetterMergeFields,
  },
  data: () => ({
    dialog: false,
    previewDialog: false,
    mergeFieldsDialog: false,
    loaderDialog: false,
    add: false,
    template: new LetterTemplate(),
    initialDocFile: "",
    headers: [
      { text: "ID", value: "id", sortable: false, width: 100 },
      { text: "Title", value: "title", sortable: false, width: 500 },
      { text: "Action", value: "action", sortable: false, width: 350 },
    ],
    templates: [],
    message: "Retrieving all templates",
  }),
  watch: {
    dialog: function (newVal) {
      if (!newVal) {
        this.loadTemplates();
      }
    },
  },
  methods: {
    ...mapActions("template", [
      "getLetterTemplate",
      "deleteLetterTemplate",
      "getLetterTemplateFile",
      "downloadLetterTemplateFile",
      "sendLetterTemplate",
    ]),
    loadTemplates() {
      this.dialog = false;
      this.loaderDialog = true;
      this.getLetterTemplate().then((data) => {
        if (data) {
          this.templates = data.map((e) => {
            return { ...e, ...e.template };
          });
          this.loaderDialog = false;
        }
      });
    },
    edit(item) {
      this.template = item;
      this.add = false;
      this.dialog = !this.dialog;
    },
    submit(preview = false, filename = "") {
      let vm = this;
      vm.generatePreview(preview);
      let payload = JSON.stringify({});
      vm.sendLetterTemplate({
        filename: filename,
        data: payload,
        preview: preview,
      })
        .then((res) => {
          if (preview) {
            vm.initialDocFile = `${
              process.env.API
            }/api/reminder/GetLetterTemplateFile/preview-${filename.replace(
              "docx",
              "pdf"
            )}`;
          }
          vm.loaderDialog = false;
          vm.previewDialog = true;
        })
        .catch((err) => {
          vm.err = err;
          vm.loaderDialog = false;
        });
    },
    generatePreview(preview) {
      if (preview) {
        this.message = "Generating Preview";
      } else {
        this.message = "Submitting";
      }
      this.loaderDialog = true;
    },
    preview(item) {
      let vm = this;
      this.submit(true, item.docFile);
      vm.template = item;
    },
    download(item) {
      let vm = this;
      try {
        vm.downloadLetterTemplateFile(item.docFile).then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: res.type,
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.docFile);
          document.body.appendChild(link);
          link.click();
        });
      } catch (err) {
        alert(err.message);
      }
    },
    closeDialog() {
      let vm = this;
      vm.dialog = false;
      this.loaderDialog = false;
    },
    closeFieldDialog() {
      let vm = this;
      vm.mergeFieldsDialog = false;
      this.loaderDialog = false;
    },
    getDeleteConfirm() {
      return window.confirm("Do you really want to delete this template?");
    },
    deleteTemplate(item) {
      if (this.getDeleteConfirm()) {
        this.deleteLetterTemplate(item).then((data) => {
          if (data.length != 0) {
            this.loadTemplates();
          }
        });
      }
    },
    addTemplate() {
      this.template = new LetterTemplate();
      this.add = true;
      this.dialog = true;
    },
    mergeFields() {
      this.mergeFieldsDialog = true;
    },
  },
  mounted() {
    setTimeout(() => {
      this.loadTemplates();
    }, 100);
  },
};
</script>

<style>
.previewDialog {
  overflow: hidden !important;
}
</style>